export default {
	login: "Entrar",
	email: "E-mail",
	password: "Senha",
	newPassword: "Nova Senha",
	confirmPassword: "Confirmar Senha",
	username: "Nome de usuário",
	inviteCode: "Código de Convite",
	forgotPassword: "Esqueci minha senha",
	forgotPasswordSubtitle: "Digite seu email para receber um link de recuperação",
	resetPassword: "Redefinir senha",
	resetPasswordSubtitle: "Digite sua nova senha",
	sendResetLink: "Enviar link de recuperação",
	backToLogin: "Voltar para login",
	emailSent: "Email enviado!",
	checkYourEmail: "Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.",
	invalidToken: "Link inválido",
	invalidTokenMessage: "Este link expirou ou é inválido. Solicite um novo link de recuperação.",
	requestNewLink: "Solicitar novo link",
	passwordChanged: "Senha alterada!",
	passwordChangedMessage: "Sua senha foi alterada com sucesso. Faça login para continuar.",
	passwordsDoNotMatch: "As senhas não conferem",
	resetError: "Erro ao redefinir senha. Tente novamente.",
	welcomeBack: "Bem-vindo de volta",
	loginSubtitle: "Entre em sua conta para continuar",
	createAccount: "Criar nova conta",
	registerSubtitle: "Junte-se ao sistema ORI",
	createAccountButton: "Criar conta",
	noAccount: "Não tem conta? Cadastre-se",
	hasAccount: "Já tem conta? Faça login",
	haveInviteCode: "Tem um código de convite? Ative aqui",
	systemDescription: "Gerencie seu templo com respeito às tradições e tecnologia moderna",
	welcomeToOri: "Bem-vindo ao ORI",
	registerDescription: "Comece sua jornada na gestão espiritual com o melhor sistema para templos",
	features: {
		people: "Gestão de Pessoas",
		peopleDesc: "Cadastro, frequência e acompanhamento",
		journey: "Jornada Espiritual",
		journeyDesc: "Guias, orixás e etapas de desenvolvimento",
		rituals: "Rituais e Giras",
		ritualsDesc: "Agenda, tipos e controle de presença",
		financial: "Controle Financeiro",
		financialDesc: "Fundos, inscrições, pagamentos e relatórios",
		communication: "Comunicação",
		communicationDesc: "Mensagens, TV e suporte",
		reports: "Painel e Relatórios",
		reportsDesc: "Dashboard e visão geral",
	},
	messages: {
		registerSuccess: "Usuário registrado com sucesso! Redirecionando para login...",
		loginError: "Erro ao fazer login",
		registerError: "Erro ao registrar usuário",
	},
};
